import { render } from "./CarterProfileEdit.vue?vue&type=template&id=6652f674&scoped=true"
import script from "./CarterProfileEdit.vue?vue&type=script&lang=js"
export * from "./CarterProfileEdit.vue?vue&type=script&lang=js"

import "./CarterProfileEdit.vue?vue&type=style&index=0&id=6652f674&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6652f674"]])

export default __exports__